import { FC, ReactNode } from 'react';
import { Provider } from 'react-redux';

import { store } from '../store';

interface IProviders {
  readonly children: ReactNode;
}

export const Providers: FC<IProviders> = ({ children }) => (
  <Provider store={store}>{children}</Provider>
);
